import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

Vue.config.productionTip = false

// 引入公共样式
import 'assets/css/style.css' 

// 数据请求
import apicall from './config/apicall'
Vue.prototype.$apicall = apicall

// 通用方法
import util from './config/util'
Vue.prototype.$util = util

// 通用方法
import VueTouch from './config/vuetouch'
Vue.use(VueTouch)

// 解决点透问题
import FastClick from 'fastclick'
if('addEventListener' in document) {
    document.addEventListener('DOMContentLoaded', function(){
        FastClick.attach(document.body)
    }, false)
}

// 加载自定义 loading 组件
import Loading from '@/components/Loading'
Vue.component('Loading', Loading)

import BetterScroll from '@/components/BetterScroll'
Vue.component('BetterScroll', BetterScroll)

// 增加百度统计
router.beforeEach((to, from, next) => {
    if (_hmt) {
        if (to.path) {
            _hmt.push(['_trackPageview', '/#' + to.fullPath]);
        }
    }
    next();
});

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')

/*

https://github.com/AntonySufer/vue-readle

<template>

</template>

<script>
    
</script>

<style>
    
</style>

*/